import React from "react";
import logo from "../../../../../assets/fe-images/logo.png";
import { Link, useLocation } from "react-router-dom";

export const Navbar = () => {
  const location = useLocation();
  return (
    <div>
      <nav>
        <div className="nav-container">
          <div className="logo">
            <img src={logo} alt=""/>
          </div>
          <div className="links-side-btns">
            <ul className="links">
              <li>
                <Link to="/"
                  className={`${
                    location.pathname == "/" ? "active" : ""
                  }`}
                >
                  Home
                </Link>
              </li>
              <li>
                <a href="#">Features</a>
              </li>
              <li>
                <a href="#">How it works</a>
              </li>
              <li>
                <a href="#">Octo For</a>
              </li>
              <li>
                <a href="#">Pricing</a>
              </li>
            </ul>
            <ul className="side-bnts">
              <li>
                <Link to="/admin/login">
                  <button className="btn login">Login</button>
                </Link>
              </li>
              <li>
                <Link to="/signup">
                  <button className="btn signup">Signup</button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};
